import IConnectedCalendar from '@/types/IConnectedCalendar';
import { Box, Switch, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface ISecondaryCalendarsToggleProps {
	calendars: IConnectedCalendar[];
	isChecked: boolean;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function SecondaryCalendarsToggle(props: ISecondaryCalendarsToggleProps) {
	const { t } = useTranslation();

	if (!props.calendars.length) {
		return null;
	}

	return (
		<Box mt="4" px="3">
			<Text display="block" as="label" htmlFor="calendar-filter" size="sm" cursor="pointer">
				{t('Display secondary calendars')}
			</Text>
			<Switch
				id="calendar-filter"
				isChecked={props.isChecked}
				name="calendar-filter"
				onChange={props.onChange}
				size="sm"
			/>
		</Box>
	);
}
